var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "hotel_class"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2069_2449",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2069_2449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hotel_class_2",
    d: "M9.18204 26.3994C8.95469 26.5823 8.71494 26.5913 8.46281 26.4263C8.21068 26.2614 8.13162 26.0362 8.22564 25.7507L10.3025 18.9431L4.96928 15.1098C4.7197 14.9406 4.64064 14.7133 4.73211 14.4278C4.82355 14.1423 5.01629 13.9996 5.31031 13.9996H11.941L14.0845 6.92791C14.129 6.76722 14.2059 6.65354 14.3153 6.58687C14.4247 6.52021 14.5418 6.48687 14.6666 6.48687C14.7914 6.48687 14.9084 6.52021 15.0178 6.58687C15.1272 6.65354 15.2042 6.76722 15.2486 6.92791L17.3922 13.9996H24.0228C24.3169 13.9996 24.5096 14.1423 24.601 14.4278C24.6925 14.7133 24.6135 14.9406 24.3639 15.1098L19.0306 18.9431L21.1075 25.7507C21.2015 26.0362 21.1225 26.2614 20.8703 26.4263C20.6182 26.5913 20.3785 26.5823 20.1511 26.3994L14.6666 22.2456L9.18204 26.3994ZM11.4666 22.1995L14.6666 19.7457L17.8666 22.1995L16.6666 18.1329L19.6794 15.9995H15.9332L14.6666 11.8662L13.3999 15.9995H9.65374L12.6666 18.1329L11.4666 22.1995ZM25.0049 26.3994L23.8075 25.4892L22.1101 19.9969L25.9357 17.2688H27.4485C27.4348 17.2688 27.5497 17.4158 27.7933 17.7098C28.0369 18.0038 28.0468 18.2269 27.8228 18.379L24.4613 20.7944L25.9818 25.7302C26.0673 25.99 25.9228 26.1674 25.5485 26.2622C25.1741 26.3571 24.9929 26.4028 25.0049 26.3994ZM19.3794 11.3329L18.5973 8.70221L19.1255 6.94071C19.17 6.78004 19.2469 6.66295 19.3563 6.58944C19.4657 6.51593 19.5828 6.47917 19.7076 6.47917C19.8324 6.47917 19.9494 6.51935 20.0588 6.59971C20.1682 6.68004 20.2452 6.79371 20.2896 6.94071L21.6409 11.3329H19.3794Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRmIcon);
export default __webpack_public_path__ + "static/media/RM-icon.7fd8ff53693eab653bac4b51073b8d4c.svg";
export { ForwardRef as ReactComponent };